
  export default {
    hydrate(data: any, container: HTMLElement) {
      const React = require('react');
      const ReactDOMClient = require('react-dom/client');
      const { default: Component } = require('/app/src/components/popular-box/PopularBox');
      ReactDOMClient.hydrateRoot(container, <Component {...data} />);
    },
  };
